import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { Card } from '@hivebrite/design-system/Card';

import type { Program } from 'hb-react/frontoffice/apps/Mentoring/types';
import { getLowerCaseMenteeLabel } from 'hb-react/frontoffice/apps/Mentoring/utils';
import { Textarea } from 'hb-react/shared/components/formik/components/inputs';
import { HtmlContent } from 'hb-react/shared/components/HtmlContent';

interface MenteeToMentorFormContentProps {
  program: Program;
  mentorName: string;
  dataTestId: string;
}

export const MenteeToMentorFormContent = ({
  program,
  mentorName,
  dataTestId,
}: MenteeToMentorFormContentProps) => {
  const navigate = useNavigate();
  const {
    applied_to_be_mentee_text: appliedToBeMenteeText,
    mentee_label: menteeLabel,
  } = program;

  const onCancel = () => {
    navigate('../../../mentors');
  };

  return (
    <Card
      pb={{ _: 6, m: 8 }}
      noBorderRadiusOnSmallScreen
      data-testid={dataTestId}
    >
      <TitleStyled as="h1">
        {s__('Mentoring|Apply to become %{name}’s %{label}').i__({
          name: mentorName,
          label: getLowerCaseMenteeLabel(menteeLabel),
        })}
      </TitleStyled>
      <Box mt={4} className="ckeditor-content--reset">
        <HtmlContent content={appliedToBeMenteeText} />
      </Box>
      <Textarea
        id="message"
        name="message"
        placeholder={s__(
          'Mentoring|Tell us more about your motivation and goals',
        )}
        label={s__('Mentoring|Message')}
        validate={{ required: true }}
        minHeight={180}
      />
      <Box justifyContent="flex-end">
        <Button variant="secondary" onClick={onCancel} mr={4}>
          {__('Cancel')}
        </Button>
        <Button type="submit">{__('Send')}</Button>
      </Box>
    </Card>
  );
};

const TitleStyled = styled(Box).attrs({
  font: 'h3-semibold',
  display: 'block',
})`
  overflow-wrap: anywhere;
`;
